import ReactMultiSelectDropdownInput from './ReactMultiSelectDropdownInput'

export default ReactMultiSelectDropdownInput



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/components/ReactMultiSelectDropdownInput/index.js